import React from 'react';

import { LiveContextTypes } from './HtmlLiveProvider'
import CssEditor from './CssEditor'

const CssLiveEditor = (props, { css, onCssChange }) => (
  <CssEditor
    {...props}
    code={css}
    onChange={code => onCssChange(code) }
  />
)

CssLiveEditor.contextTypes = LiveContextTypes

export default CssLiveEditor



// WEBPACK FOOTER //
// ./src/book/editors/CssLiveEditor.js